export const state = {
  groups: [],
  isLoading: false,
  totalRecords: 0,
  groupPerPage: 10000,
  activePage: 1
}
